import React from "react";
import { VegaFont } from "@heartlandone/vega-react";
import { ACTIVITY_STATUS } from "Chore/Constants";

const { STATUS_LABEL } = ACTIVITY_STATUS;

function ActivityChargeInline({ activityStatus, chargeAmount }) {
  return (
    <VegaFont
      color={
        activityStatus === STATUS_LABEL.CLOSED
          ? "text-disabled"
          : "text-success"
      }
      variant="font-field-value-em"
    >
      {chargeAmount <= 0 ? `Free` : `$${chargeAmount}`}
    </VegaFont>
  );
}

export default ActivityChargeInline;
